import React, {useLayoutEffect, useRef, useState} from 'react';
import {readSharedView, useSharedReport} from './useSharedReport';

// Scope repeated titles (for example, Monthly calls) by their enclosing reports.
export function SharedGraph({title, shareId, children, kind = 'graph'}) {
  const ref = useRef(null);
  const [identity, setIdentity] = useState(null);
  useLayoutEffect(() => {
    const node = ref.current;
    const ancestors = [];
    for (let parent = node.parentElement; parent; parent = parent.parentElement) {
      if (parent.id) ancestors.unshift(parent.id);
    }
    const open = [...document.querySelectorAll('button[aria-controls]')]
      .filter(button => { const content = document.getElementById(button.getAttribute('aria-controls')); return content ? content.contains(node) : button.dataset.sharedToggle && button.parentElement?.parentElement?.contains(node); })
      .map(button => button.getAttribute('aria-controls'));
    const base = `${kind}-${[...ancestors, title || 'chart'].join('--').toLowerCase().replace(/[^a-z0-9-]+/g, '-')}`;
    const peers = kind === 'table' ? [...document.querySelectorAll('[data-share-kind="table"]')].filter(other => other.dataset.shareName === (title || 'chart') && other.parentElement?.closest('[id]') === node.parentElement?.closest('[id]')) : [];
    const ordinal = peers.indexOf(node);
    const id = shareId || (ordinal > 0 ? `${base}-${ordinal + 1}` : base);
    node.id = id;
    node.dataset.shareOpen = JSON.stringify([...new Set(open)]);
    const previousView = readSharedView();
    if (identity && identity !== id && previousView?.id === identity) {
      const url = new URL(window.location.href);
      url.searchParams.set('view', JSON.stringify({...previousView, id, open}));
      url.hash = id;
      window.history.replaceState(window.history.state, '', url);
    }
    setIdentity(id);
    if (readSharedView()?.id === id) requestAnimationFrame(() => node.scrollIntoView?.({block:'start'}));
  }, [shareId, title, identity, kind]);
  return <div ref={ref} data-share-kind={kind} data-share-name={title || 'chart'} className="scroll-mt-24">{identity && children(identity)}</div>;
}

function StaticGraphContent({id, children}) {
  const activate = useSharedReport(id, undefined, {});
  return <div onClick={activate} onChange={activate}>{children}</div>;
}
export function ShareableStaticGraph({title, children}) {
  return <SharedGraph title={title}>{id => <StaticGraphContent id={id}>{children}</StaticGraphContent>}</SharedGraph>;
}
